import { Icon, HelpCircleIcon } from 'components/shared/Icon/Icon'
import { useTooltip } from 'hooks'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'
import { Arrow } from 'components/shared/Arrow/Arrow'
import React from 'react'
import type { Placement } from '@floating-ui/react-dom'
import { Box } from 'components/layout/Box/Box'
import styles from './IconTooltip.module.scss'

type IconTooltipProps = {
  text?: React.ReactNode
  icon?: React.ComponentProps<typeof Icon>['icon']
  className?: string
  iconClassName?: string
  size?: number
  placement?: Placement
}

export const IconTooltip = ({
  text,
  icon = HelpCircleIcon,
  className,
  iconClassName,
  size,
  placement = 'right-end',
}: IconTooltipProps) => {
  const {
    state: {
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      reference,
      hasArrow,
      isToggled,
    },
    handlers: {
      handleBlur,
      handleFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleTouchEnd,
      handleTouchStart,
    },
  } = useTooltip({ initialPlacement: placement })

  return (
    <>
      <span
        className={className}
        {...{
          ref: reference,
          onBlur: handleBlur,
          onFocus: handleFocus,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          onTouchStart: handleTouchStart,
          onTouchEnd: handleTouchEnd,
        }}
      >
        {/* the default colour is dropped rather than merged, since both rules
            are a single class and the winner would come down to bundle order */}
        <Icon className={iconClassName || styles.icon} {...{ icon, size }} />
      </span>
      <TetherPortal isOpen={isToggled}>
        <Box
          align="left"
          className={styles.message}
          justify="left"
          ref={floating}
          // TODO(a11y): was role="status", which <Box> silently drops. Restore as
          // ariaRole once the DOM change can be verified in the UI.
          style={floatingStyle}
        >
          {hasArrow && (
            <Arrow
              ref={arrowRef}
              size="small"
              style={arrowStyle}
              theme="bright"
            />
          )}
          <Box
            align="start"
            className={styles.content}
            direction="column"
            // TODO(a11y): was role="tooltip", which <Box> silently drops. Restore as
            // ariaRole once the DOM change can be verified in the UI.
          >
            <div className={styles.tooltipTitle}>{text}</div>
          </Box>
        </Box>
      </TetherPortal>
    </>
  )
}
